import { DSPData } from "../../components/types/types";
import { SelectedDSPs } from "../types/form";

const platformToDspTypeMap: Record<string, string> = {
  spotify: "spotify",
  amazon: "amazon_music",
  deezer: "deezer",
  audiomack: "audio_mack",
  apple: "apple_music",
  TIDAL: "tidal",
  youtube: "youtube_music",
};

export const validateSelectedDSPs = (
  selectedDSPs: Partial<SelectedDSPs>,
  dspList: DSPData[]
): { isValid: boolean; missingPlatforms: string[] } => {
  const missingPlatforms: string[] = [];

  const selectedPlatforms = Object.entries(selectedDSPs)
    .filter(([platform, isSelected]) => isSelected && platform !== "email")
    .map(([platform]) => platform);

  for (const platform of selectedPlatforms) {
    const dspType = platformToDspTypeMap[platform];

    if (dspType) {
      const hasConnectedAccount = dspList.some((dsp) => dsp.type === dspType);

      if (!hasConnectedAccount) {
        missingPlatforms.push(platform);
      }
    }
  }

  return {
    isValid: missingPlatforms.length === 0,
    missingPlatforms,
  };
};
